import { Suspense } from 'react';
import AdministrationModule from './AdministrationModule';
const AdministrationModuleProxy = () => (
  <div>
    <Suspense fallback={<div />}>
      <AdministrationModule />
    </Suspense>
  </div>
);

export default AdministrationModuleProxy;
